import { useEffect, useRef, useState } from 'react'
import { initializeSimulation } from '../../utils/simulator/simulationEngine'

export default function SimulatorCanvas({ isPaused, onActivityAdd, onMarketDataUpdate }) {
  const containerRef = useRef(null)
  const simulationRef = useRef(null)

  useEffect(() => {
    if (containerRef.current && !simulationRef.current) {
      // Initialize the simulation
      simulationRef.current = initializeSimulation(
        containerRef.current,
        onActivityAdd,
        onMarketDataUpdate
      )
    }

    return () => {
      // Cleanup on unmount
      if (simulationRef.current && simulationRef.current.cleanup) {
        simulationRef.current.cleanup()
      }
    }
  }, [onActivityAdd, onMarketDataUpdate])

  useEffect(() => {
    // Handle pause/resume
    if (simulationRef.current) {
      if (isPaused) {
        simulationRef.current.pause()
      } else {
        simulationRef.current.resume()
      }
    }
  }, [isPaused])

  return (
    <div 
      ref={containerRef}
      className={`relative w-full max-w-[1400px] h-[800px] mx-auto ${isPaused ? 'simulation-paused' : ''}`}
      style={{
        background: 'radial-gradient(circle at center, rgba(102, 126, 234, 0.05), transparent 70%)'
      }}
    >
      {/* SVG for connection lines */}
      <svg 
        className="absolute inset-0 w-full h-full pointer-events-none z-[1]" 
        id="connectionLines"
      >
        <defs>
          <marker 
            id="arrowhead" 
            markerWidth="10" 
            markerHeight="10" 
            refX="9" 
            refY="3" 
            orient="auto"
          >
            <polygon points="0 0, 10 3, 0 6" fill="#444" opacity="0.6" />
          </marker>
        </defs>
      </svg>

      {/* Circles will be created by the simulation engine */}
      <div id="simulator-circles" className="relative w-full h-full z-10"></div>

      {/* Visual guide circle */}
      <div 
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] border-2 border-dashed border-[#444] rounded-full opacity-40 z-[5] pointer-events-none"
        style={{
          boxShadow: 'inset 0 0 50px rgba(102, 126, 234, 0.1)'
        }}
      />
    </div>
  )
}

